<template>
  <section class="small-12 medium-12 large-6 columns">
    <h1 v-html="vueModel.ContentViewModel.Step3Pet.StepTitle" />

    <article v-if="stepModel.ProductSpecific.BodyDamageList">
      <h2 v-html="vueModel.ContentViewModel.Step3Pet.PetSecondTitle" />
      <pet-body-parts
        v-model="vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems"
        :body-damage-list="stepModel.ProductSpecific.BodyDamageList"
        name="body-area"
      />
    </article>
  </section>
</template>

<script>
import ReportClaimMixin from '@/components/Feature/Claims/flows/ReportClaimMixin.vue';
import ReportClaimServicesMixin from '@/components/Feature/Claims/flows/ReportClaimServicesMixin.vue';
import PetBodyParts from '../../components/PetBodyParts/PetBodyParts.vue';

export default {
  name: 'ReportClaimPetStep3',
  components: { PetBodyParts },
  mixins: [ReportClaimMixin, ReportClaimServicesMixin],
  props: {
    vueModel: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      stepModel: this.vueModel.CreateClaimStep3Model
    };
  },
  mounted() {
    if (this.vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems === null) {
      this.vueModel.CreateClaimEntity.ProductSpecific.SelectedBodyDamagedItems = [];
    }

    if (this.vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems === null) {
      this.vueModel.CreateClaimEntity.ProductSpecific.SelectedTeethDamagedItems = [];
    }
  }
};
</script>
